import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import './Player.css';

const Player = ({ link, isModalOpen, width = '100%', height = '385px', borderRadius = '8px' }) => {
  const videoRef = useRef(null);
  const hlsInstance = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !link) return;

    if (Hls.isSupported()) {
      const hls = new Hls({
        maxBufferLength: 30,
        maxMaxBufferLength: 30,
        maxBufferSize: 50 * 1000 * 1000,
        maxBufferHole: 1,
        startLevel: -1,
      });
      hlsInstance.current = hls;
      hls.loadSource(link);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch((error) =>
          console.error('Erro ao reproduzir o vídeo automaticamente:', error)
        );
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = link;
      video.addEventListener('loadedmetadata', () => {
        video.play().catch((error) =>
          console.error('Erro ao reproduzir o vídeo automaticamente:', error)
        );
      });
    }

    return () => {
      if (hlsInstance.current) hlsInstance.current.destroy();
      if (video) {
        video.pause();
        video.src = '';
      }
    };
  }, [link]);

  useEffect(() => {
    if (isModalOpen !== undefined && !isModalOpen && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isModalOpen]);

  return (
    <div
      className="video-container"
      style={{
        width,
        height,
        borderRadius,
        overflow: 'hidden',
      }}
    >
      <video
        ref={videoRef}
        controls
        style={{
          width: '100%',
          height: '100%',
          borderRadius,
          objectFit: 'cover',
        }}
        playsInline
        webkit-playsinline="true"
      />
    </div>
  );
};

export default Player;
